import slugify from 'slugify';
import { CountryCode, parsePhoneNumberFromString } from 'libphonenumber-js';

export function rtrimChar(str: string, char: string = '/') {
    return str.endsWith(char) ? str.substring(0, str.length - 1) : str;
}

export function ltrimChar(str: string, char: string = ''): string {
    str = str.startsWith(char) ? str.substring(1) : str;
    return str;
}

export function isJson(str: string): boolean {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

export function blobToBase64(blob: Blob) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = () => reject('');
        reader.readAsDataURL(blob);
    });
}

export function urlBase64ToUint8Array(base64String: string) {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = base64String.replace(/-/g, '+').replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

export function createSlug(str: string) {
    return slugify(str ?? '', {
        replacement: '-',
        remove: undefined,
        lower: true,
        strict: false,
        locale: 'vi',
        trim: true,
    });
}

export function createExcerpt(description: string, maxLength = 250): string {
    const trimmed = description.slice(0, maxLength - 3);
    return trimmed + '...';
    //return trimmed.slice(0, trimmed.lastIndexOf(' ')) + '…'; // avoid cutting words
}

export const trimWs = (v: string) => v.replace(/\s+/g, '');

export const normalizeWhitespace = (v: string) => v.replace(/\s+/g, ' ').trim();

export const nfc = (v: string) => v.normalize('NFC');

export function normalizeEmail(email: string): string {
    return email.trim().toLowerCase().normalize('NFC');
}

export const normalizeHuman = (v?: string | null) =>
    typeof v === 'string' ? nfc(normalizeWhitespace(v)) : v;

export const normalizePhone = (v?: string | null) => (typeof v === 'string' ? trimWs(v) : v);

export function hasWhitespaceOrControl(s: unknown): boolean {
    if (typeof s !== 'string') return false;
    return /[\s\u00A0\u200B-\u200D\u2060\uFEFF\u0000-\u001F\u007F-\u009F]/.test(s);
}

export function hasControlChars(s: unknown): boolean {
    if (typeof s !== 'string') return false;

    // real chars
    if (/[\u0000-\u001F\u007F-\u009F\u200B-\u200D\u2060\uFEFF]/.test(s)) return true;

    // controls as text \uXXXX
    if (/\\u[0-9A-Fa-f]{4}/.test(s)) return true;

    return false;
}

export function hasLeadingOrTrailingWhitespace(s: unknown): boolean {
    if (typeof s !== 'string') return false;
    return s !== s.trim();
}

export function timingSafeEqualStr(a: string, b: string): boolean {
    const len = Math.max(a.length, b.length);
    let diff = a.length ^ b.length;
    for (let i = 0; i < len; i++) diff |= (a.charCodeAt(i) || 0) ^ (b.charCodeAt(i) || 0);
    return diff === 0;
}
